import { CalendarTypeModel } from '.'
import { isUnknownObject, isBoolean } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class Calendar extends BaseModel {
  id: string = ''
  name: string = ''
  alias: string = ''
  description: string = ''
  isPublic: boolean = false
  isShared: boolean = false
  type: CalendarTypeModel | null = null

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['type', 'is_public', 'is_shared'])

      if (isUnknownObject(data.type)) {
        this.type = new CalendarTypeModel(data.type)
      }

      if (isBoolean(data.is_public)) {
        this.isPublic = data.is_public
      }

      if (isBoolean(data.is_shared)) {
        this.isShared = data.is_shared
      }
    }
  }
}
